import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import HomePage from "./pages/HomePage/HomePage";
import Layout from "./components/Layout";
import NotFoundPage from "./pages/NotFoundPage/NotFoundPage";
import FighterPage from "./pages/FighterPage/FighterPage";
import { getCurrentUser, useUserDispatch } from "./providers/UserProvider";
import { SelectedFightersProvider } from "./providers/SelectedFightersProvider";
import { DrawerControlProvider } from "./providers/DrawerControlProvider";
import { TeamPage } from "./pages/TeamPage/TeamPage";
import DictPage from "./pages/DictPage/DictPage";
import LeaderboardPage from "./pages/LeaderboardPage/LeaderboardPage";

export default function App() {
  const userDispatch = useUserDispatch();

  useEffect(() => {
    getCurrentUser(userDispatch).then(() =>
        console.log("getCurrentUser in useEffect completed")
    );
  }, [userDispatch]);

  return (
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="dict" element={<DictPage />} />
          <Route path="leaderboard" element={<LeaderboardPage />} />
          <Route
              path="roster/:id"
              element={
                <DrawerControlProvider>
                  <SelectedFightersProvider>
                    <TeamPage />
                  </SelectedFightersProvider>
                </DrawerControlProvider>
              }
          />
          <Route path="fighter/:id" element={<FighterPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
  );
}